export interface PhoneCountry {
    name: string
    iso2: string
    dialCode: string
}

export const COUNTRIES: PhoneCountry[] = [
    { name: 'New Zealand', iso2: 'nz', dialCode: '64' },
    { name: 'Australia', iso2: 'au', dialCode: '61' },
    { name: 'United Kingdom', iso2: 'gb', dialCode: '44' },
    { name: 'United States', iso2: 'us', dialCode: '1' },
    { name: 'Canada', iso2: 'ca', dialCode: '1' },
    { name: 'Ireland', iso2: 'ie', dialCode: '353' },
    { name: 'South Africa', iso2: 'za', dialCode: '27' },
    { name: 'Singapore', iso2: 'sg', dialCode: '65' },
    { name: 'Afghanistan', iso2: 'af', dialCode: '93' },
    { name: 'Albania', iso2: 'al', dialCode: '355' },
    { name: 'Algeria', iso2: 'dz', dialCode: '213' },
    { name: 'Argentina', iso2: 'ar', dialCode: '54' },
    { name: 'Armenia', iso2: 'am', dialCode: '374' },
    { name: 'Austria', iso2: 'at', dialCode: '43' },
    { name: 'Azerbaijan', iso2: 'az', dialCode: '994' },
    { name: 'Bahrain', iso2: 'bh', dialCode: '973' },
    { name: 'Bangladesh', iso2: 'bd', dialCode: '880' },
    { name: 'Belgium', iso2: 'be', dialCode: '32' },
    { name: 'Bolivia', iso2: 'bo', dialCode: '591' },
    { name: 'Brazil', iso2: 'br', dialCode: '55' },
    { name: 'Bulgaria', iso2: 'bg', dialCode: '359' },
    { name: 'Cambodia', iso2: 'kh', dialCode: '855' },
    { name: 'Chile', iso2: 'cl', dialCode: '56' },
    { name: 'China', iso2: 'cn', dialCode: '86' },
    { name: 'Colombia', iso2: 'co', dialCode: '57' },
    { name: 'Costa Rica', iso2: 'cr', dialCode: '506' },
    { name: 'Croatia', iso2: 'hr', dialCode: '385' },
    { name: 'Cyprus', iso2: 'cy', dialCode: '357' },
    { name: 'Czech Republic', iso2: 'cz', dialCode: '420' },
    { name: 'Denmark', iso2: 'dk', dialCode: '45' },
    { name: 'Ecuador', iso2: 'ec', dialCode: '593' },
    { name: 'Egypt', iso2: 'eg', dialCode: '20' },
    { name: 'Estonia', iso2: 'ee', dialCode: '372' },
    { name: 'Ethiopia', iso2: 'et', dialCode: '251' },
    { name: 'Finland', iso2: 'fi', dialCode: '358' },
    { name: 'France', iso2: 'fr', dialCode: '33' },
    { name: 'Georgia', iso2: 'ge', dialCode: '995' },
    { name: 'Germany', iso2: 'de', dialCode: '49' },
    { name: 'Ghana', iso2: 'gh', dialCode: '233' },
    { name: 'Greece', iso2: 'gr', dialCode: '30' },
    { name: 'Guatemala', iso2: 'gt', dialCode: '502' },
    { name: 'Hong Kong', iso2: 'hk', dialCode: '852' },
    { name: 'Hungary', iso2: 'hu', dialCode: '36' },
    { name: 'Iceland', iso2: 'is', dialCode: '354' },
    { name: 'India', iso2: 'in', dialCode: '91' },
    { name: 'Indonesia', iso2: 'id', dialCode: '62' },
    { name: 'Israel', iso2: 'il', dialCode: '972' },
    { name: 'Italy', iso2: 'it', dialCode: '39' },
    { name: 'Jamaica', iso2: 'jm', dialCode: '1876' },
    { name: 'Japan', iso2: 'jp', dialCode: '81' },
    { name: 'Jordan', iso2: 'jo', dialCode: '962' },
    { name: 'Kazakhstan', iso2: 'kz', dialCode: '7' },
    { name: 'Kenya', iso2: 'ke', dialCode: '254' },
    { name: 'Kuwait', iso2: 'kw', dialCode: '965' },
    { name: 'Latvia', iso2: 'lv', dialCode: '371' },
    { name: 'Lebanon', iso2: 'lb', dialCode: '961' },
    { name: 'Lithuania', iso2: 'lt', dialCode: '370' },
    { name: 'Luxembourg', iso2: 'lu', dialCode: '352' },
    { name: 'Malaysia', iso2: 'my', dialCode: '60' },
    { name: 'Malta', iso2: 'mt', dialCode: '356' },
    { name: 'Mexico', iso2: 'mx', dialCode: '52' },
    { name: 'Morocco', iso2: 'ma', dialCode: '212' },
    { name: 'Myanmar', iso2: 'mm', dialCode: '95' },
    { name: 'Nepal', iso2: 'np', dialCode: '977' },
    { name: 'Netherlands', iso2: 'nl', dialCode: '31' },
    { name: 'Nigeria', iso2: 'ng', dialCode: '234' },
    { name: 'Norway', iso2: 'no', dialCode: '47' },
    { name: 'Oman', iso2: 'om', dialCode: '968' },
    { name: 'Pakistan', iso2: 'pk', dialCode: '92' },
    { name: 'Panama', iso2: 'pa', dialCode: '507' },
    { name: 'Peru', iso2: 'pe', dialCode: '51' },
    { name: 'Philippines', iso2: 'ph', dialCode: '63' },
    { name: 'Poland', iso2: 'pl', dialCode: '48' },
    { name: 'Portugal', iso2: 'pt', dialCode: '351' },
    { name: 'Qatar', iso2: 'qa', dialCode: '974' },
    { name: 'Romania', iso2: 'ro', dialCode: '40' },
    { name: 'Russia', iso2: 'ru', dialCode: '7' },
    { name: 'Saudi Arabia', iso2: 'sa', dialCode: '966' },
    { name: 'Serbia', iso2: 'rs', dialCode: '381' },
    { name: 'Slovakia', iso2: 'sk', dialCode: '421' },
    { name: 'Slovenia', iso2: 'si', dialCode: '386' },
    { name: 'South Korea', iso2: 'kr', dialCode: '82' },
    { name: 'Spain', iso2: 'es', dialCode: '34' },
    { name: 'Sri Lanka', iso2: 'lk', dialCode: '94' },
    { name: 'Sweden', iso2: 'se', dialCode: '46' },
    { name: 'Switzerland', iso2: 'ch', dialCode: '41' },
    { name: 'Taiwan', iso2: 'tw', dialCode: '886' },
    { name: 'Tanzania', iso2: 'tz', dialCode: '255' },
    { name: 'Thailand', iso2: 'th', dialCode: '66' },
    { name: 'Turkey', iso2: 'tr', dialCode: '90' },
    { name: 'Uganda', iso2: 'ug', dialCode: '256' },
    { name: 'Ukraine', iso2: 'ua', dialCode: '380' },
    { name: 'United Arab Emirates', iso2: 'ae', dialCode: '971' },
    { name: 'Uruguay', iso2: 'uy', dialCode: '598' },
    { name: 'Uzbekistan', iso2: 'uz', dialCode: '998' },
    { name: 'Venezuela', iso2: 've', dialCode: '58' },
    { name: 'Vietnam', iso2: 'vn', dialCode: '84' },
    { name: 'Zambia', iso2: 'zm', dialCode: '260' },
    { name: 'Zimbabwe', iso2: 'zw', dialCode: '263' },
]

export function flagEmoji(iso2: string): string {
    return iso2.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 0x1f1a5))
}
